export function nameof<T>(key: keyof T & string): keyof T & string {
  return key;
}

export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

export function enumToValueOptions(e: any): any {
  return Object.entries(e).map(([label, value]) => ({
    label,
    value,
  }));
}
